import { FC } from 'react'
import { Stack, Box, Typography } from '@mui/material'

export const PreviousChangesBox: FC = () => {
  return (
    <Stack>
      <Box
        sx={{
          bgcolor: 'var(--bg-surface)',
          borderRadius: '0.5rem',
          p: 'var(--spacing-m)',
          gap: 'var(--spacing-2xl)'
        }}
      >
        <Typography variant="h2" fontSize={'var(--size-xl)'} fontWeight="500" color="text.primary">
          Previous Scheduled Address Changes
        </Typography>
        <Box py="var(--spacing-3xl)">
          <Typography component="p" fontSize={'var(--size-l)'} fontWeight="500" color="text.primary" textAlign={'center'}>
            No Changes Yet
          </Typography>
          <Typography component="p" fontSize={'var(--size-l)'} fontWeight="300" color="text.secondary" textAlign={'center'}>
            Scheduled address changes will show up here
          </Typography>
        </Box>
      </Box>
    </Stack>
  )
}
